import classNames from "classnames";
import Size from "shared/enums/Size";
import { LinkConfig } from "../types";
import Variant from "shared/enums/Variant";
import { getUrlForHref } from "shared/utils";

function OpenLinkInNewTab({ variant = Variant.PRIMARY, size = Size.MEDIUM, ...props }: LinkConfig) {
  const computedClassNames = getClassNames(props.asButton, variant, size, props.isOutline);

  return (
    <a
      ref={el => {
        el?.style.setProperty("background-color", `${props?.backgroundColor}`, "important");
      }}
      href={getUrlForHref(props.url)}
      data-eventtype={props.dataEventType}
      data-label={props.label}
      data-url={props.url}
      target="_blank"
      rel="noopener noreferrer"
      onClick={props.onClick}
      title={props.title}
      className={classNames(computedClassNames, props.className)}>
      {props.icon}
      <span>{props.children || props.label || props.url}</span>
    </a>
  );
}

export default OpenLinkInNewTab;

function getClassNames(asButton?: boolean, variant?: Variant, size?: Size, isOutline?: boolean) {
  return classNames({
    link: true,
    "link--asBtn": asButton,
    [`link--asBtn--${variant}`]: asButton && variant,
    [`link--asBtn--${variant}--isOutlined`]: asButton && isOutline,
    [`link--asBtn-${size}`]: size
  });
}
